(() => {
  if (customElements.get("how-to-use-tabs")) return;

  class HowToUseTabs extends HTMLElement {
    constructor() {
      super();

      this.onClick = this.onClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.triggers = [...this.querySelectorAll("[data-tab-trigger]")];
      this.panels = [...this.querySelectorAll("[data-tab-panel]")];

      this.addEventListener("click", this.onClick);
      this.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    onClick(event) {
      const trigger = event.target.closest("[data-tab-trigger]");
      if (trigger) this.setActive(this.triggers.indexOf(trigger));
    }

    onBlockSelect(event) {
      const trigger = event.target.closest("[data-tab-trigger]");
      const panel = event.target.closest("[data-tab-panel]");
      const index = trigger ? this.triggers.indexOf(trigger) : this.panels.indexOf(panel);
      if (index >= 0) this.setActive(index);
    }

    setActive(activeIndex) {
      this.triggers.forEach((trigger, index) => {
        trigger.setAttribute("aria-selected", String(index === activeIndex));
      });
      this.panels.forEach((panel, index) => {
        panel.hidden = index !== activeIndex;
      });

      const mediaItems = [...this.querySelectorAll("[data-tab-media]")];
      const activeMedia =
        mediaItems.find((item) => item.dataset.tabMedia === String(activeIndex)) ||
        mediaItems.find((item) => item.dataset.tabMedia === "default");
      mediaItems.forEach((item) => {
        item.hidden = item !== activeMedia;
        const video = item.querySelector("video");
        if (!video) return;
        if (item.hidden) video.pause();
        else video.play().catch(() => {});
      });
    }
  }

  customElements.define("how-to-use-tabs", HowToUseTabs);
})();
